<template>
  <div>
    <v-row
      no-gutters
    >
      <v-col
        v-if="label !== null"
        class="mb-2 ml-1 text-body-1"
        cols="12"
      >
        {{ label }}
      </v-col>
      <v-col>
        <currency-input
          v-model="inputValue"
          :options="{ locale: 'hr', currency: 'EUR', currencyDisplay: 'hidden', precision: decimalPrecision }"
          v-bind="$attrs"
          :disabled="disabled"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CurrencyInput from '@/components/helpers/CurrencyInput.vue'

export default {
  name: 'NumberInput',
  components: { CurrencyInput },
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    decimalPrecision: {
      type: Number,
      default: 2
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
